import {ReactNode} from "react";
import {Badge} from "@chakra-ui/react";
import {CheckCircleIcon} from "@heroicons/react/20/solid";

type Props = {
  // Optional override — defaults to the full "Reliance placed" label.
  // Pass a count or other compact content for summary contexts (e.g. the
  // card's scoped-summary line).
  children?: ReactNode;
};

// Shared blue subtle badge used across the dependency-map surfaces wherever
// the auditor's reliance decision needs surfacing — unscoped cards use the
// default text label, scoped cards use a count, the scoped-control popover
// reuses the default label per-row.
export default function RelianceBadge({children}: Props) {
  return (
    <Badge
      colorPalette="blue"
      variant="subtle"
      size="xs"
      flexShrink={0}
      display="inline-flex"
      alignItems="center"
      gap="2px"
      lineHeight="1"
    >
      <CheckCircleIcon width={10} height={10} />
      {children ?? "Reliance placed"}
    </Badge>
  );
}
